import React from 'react';
const NotFoundPage = () => (
    <div className="container pt4 tc">
        <h3>Seite leider nicht gefunden</h3>
    </div>
)

export default NotFoundPage


// WEBPACK FOOTER //
// ./src/pages/NotFoundPage.js